import { render, staticRenderFns } from "./sqlReportsCategories.pug?vue&type=template&id=bde0b83c&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./sqlReportsCategories.scss?vue&type=style&index=0&id=bde0b83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde0b83c",
  null
  
)

export default component.exports